import React from "react";
import MakroAlert, { MakroAlertType } from "../common/alert";
var SubscriptionError = function SubscriptionError(_ref) {
    var errorType = _ref.errorType;
    var getErrorMessage = function getErrorMessage() {
        switch (errorType) {
            case "SUBSCRIPTION_EXISTS":
                return /*#__PURE__*/ React.createElement(React.Fragment, null, "Sie besitzen bereits das ausgew\xE4hlte Abonnement. Falls Sie Fragen haben, wenden Sie sich an ", /*#__PURE__*/ React.createElement("a", {
                    href: "mailto:aboservice@makroskop.eu"
                }, "aboservice@makroskop.eu"), ".");
            case "INVALID_DATA":
                return /*#__PURE__*/ React.createElement(React.Fragment, null, "Die eingegebenen Daten sind ung\xFCltig. Bitte \xFCberpr\xFCfen Sie Ihre Eingaben und versuchen Sie es erneut.");
            case "AUTH_REQUIRED":
                return /*#__PURE__*/ React.createElement(React.Fragment, null, "Sie m\xFCssen angemeldet sein, um ein Abonnement abzuschlie\xDFen. Bitte melden Sie sich an und versuchen Sie es erneut.");
            case "PERMISSION_DENIED":
                return /*#__PURE__*/ React.createElement(React.Fragment, null, "Sie haben keine Berechtigung f\xFCr diese Aktion. Bitte wenden Sie sich an ", /*#__PURE__*/ React.createElement("a", {
                    href: "mailto:aboservice@makroskop.eu"
                }, "aboservice@makroskop.eu"), ".");
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null, "Leider konnte Ihr Abonnement nicht erstellt werden. Bitte wenden Sie sich an ", /*#__PURE__*/ React.createElement("a", {
                    href: "mailto:aboservice@makroskop.eu"
                }, "aboservice@makroskop.eu"), ".");
        }
    };
    var getErrorTitle = function getErrorTitle() {
        switch (errorType) {
            case "SUBSCRIPTION_EXISTS":
                return "Abonnement bereits vorhanden";
            case "INVALID_DATA":
                return "Ungültige Daten";
            case "AUTH_REQUIRED":
                return "Anmeldung erforderlich";
            case "PERMISSION_DENIED":
                return "Keine Berechtigung";
            default:
                return "Es ist ein Fehler aufgetreten";
        }
    };
    return /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.DANGER,
        title: getErrorTitle(),
        text: getErrorMessage()
    });
};
export default SubscriptionError;
